// extracted by mini-css-extract-plugin
export default {"badge":"dayOffArchive_badge__f5VAF","btnsGroup":"dayOffArchive_btnsGroup__Pbb1S"};